import type { KaraokeConfig } from '../types/karaokeTypes';
import type { VariablePositionings } from '../types/karaokeVariablePositionings';

export const MAX_GAP_DURATION = 1; // in second
export const MAX_CHARS_INSTAGRAM = 14;
export const MAX_CHARS_DEFAULT = 50;

export const NATURAL_BEAT_DURATION_MS = MAX_GAP_DURATION * 1000;
export const PAUSE_DURATION_MS = 300;
export const MAX_SEGMENT_CHAR_LENGTH = 40;
export const ORPHANED_WORDS_COUNT = 2;
export const PUNCT_ELEMENT_DURATION_MS = 0; // Estimated duration for punct elements

export const FILLER_WORDS = [
  'Umm',
  'Um',
  'Uh',
  'Uhh',
  'Eh',
  'You know',
  'Ya know',
  'Hmm',
  'Hm',
  'Ah',
  'Ahh',
  'Er',
];

export const DEFAULT_VARIABLE_POSITIONINGS: VariablePositionings = {
  'stacked-1-1': {
    x: '50%',
    y: '50%',
    x_alignment: '50%',
  },
  'stacked-1-3': {
    x: '50%',
    y: '33.333%',
    x_alignment: '50%',
  },
};

export const DEFAULT_KARAOKE_CONFIG = {
  width: '76%',
  font_size: '3.333vh',
  font_weight: '400',
  fill_color: 'white',
  background_color: 'transparent',
  background_align_threshold: '0%',
  background_border_radius: '0%',
  text_wrap: true,
  x_alignment: '50%',
  y: '86%',
  x: '50%',
  line_height: '125%',
  font_family: 'Anton',
  font_style: 'normal',
  stroke_color: 'rgba(0, 0, 0, 1)',
  stroke_width: '1 vmin',
  letter_spacing: '50%',
  animations: [] as any[],
  hideComma: false,
  hidePeriod: false,
  hideFillers: false,
  instagramEffect: false,
  instagramLines: 5,
  language: 'original',
  shadow_color: null,
  shadow_blur: null,
  shadow_x: null,
  shadow_y: null,
  text_transform: 'uppercase',
  variablePositionings: DEFAULT_VARIABLE_POSITIONINGS,
} as KaraokeConfig;

export const WORDS_TIMESTAMP_FLOAT_ERROR = 1e-6;

export const DEFAULT_TEXT_TRANSCRIPT_CONFIG = {
  // transcript_effect is skipped on purpose, it will be used as flag to know if
  // user activated the transcript settings
  transcript_split: 'word',
  transcript_placement: 'animate',
  transcript_maximum_length: 100,
  transcript_color: 'rgba(231, 76, 60, 1)',
};
